import { cx } from "class-variance-authority";
import React from "react";

type RegistrationWrapperProps = {
  children: React.ReactNode;
  orgColor?: string;
};

export const RegistrationWrapper = ({
  children,
  orgColor,
}: RegistrationWrapperProps) => {
  return (
    <div className="w-screen relative py-4 h-screen bg-white overflow-y-auto flex justify-center">
      <div
        className="bg-navy w-full fixed h-[25vh] top-0"
        style={{
          backgroundColor: orgColor,
        }}
      />
      <div className="bg-friendly-eskimo fixed top-[25vh] bottom-0 left-0 right-0" />
      <div
        className={cx(
          "absolute inset-0 bg-white h-screen w-screen shadow rounded overflow-y-auto",
          "md:max-w-lg md:inset-auto md:mx-auto md:h-auto"
        )}
      >
        {children}
      </div>
    </div>
  );
};
